import { render } from "./NoCropsInfo.vue?vue&type=template&id=13f5f796&scoped=true"
import script from "./NoCropsInfo.vue?vue&type=script&lang=js"
export * from "./NoCropsInfo.vue?vue&type=script&lang=js"

import "./NoCropsInfo.vue?vue&type=style&index=0&id=13f5f796&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f5f796"]])

export default __exports__